import { VAutocomplete, VCombobox, VSelect } from 'vuetify/lib'

// Vuetify 2 has no global "defaults" API (that only exists in Vuetify 3), so
// the only way to change every v-select/v-autocomplete/v-combobox dropdown
// at once — instead of passing :menu-props on each usage — is to overwrite
// the shared prop definition's default factory here, once, before any
// component instance is created. Without offsetY/top, Vuetify overlays the
// menu directly on top of the field (native-<select>-style) and then shoves
// it further up whenever the overlay would overflow the viewport, which is
// why selects were randomly rendering above the field or off-screen.
const belowFieldMenuProps = () => ({
	closeOnClick: false,
	closeOnContentClick: false,
	disableKeys: true,
	openOnClick: false,
	maxHeight: 304,
	top: false,
	offsetY: true,
})

;[VSelect, VAutocomplete, VCombobox].forEach(component => {
	component.options.props.menuProps.default = belowFieldMenuProps
})
